export default "__VITE_ASSET__CQhlBAdW__"